export default __webpack_public_path__ + "media/images/ogp/ot_ogp2-89b682206688f11cc7cf9713efa3186a.jpg";